module.exports = __webpack_public_path__ + "img/receipt.9f6c9d11.svg";